// React and Hooks
import { useEffect, useState } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  setAllDataForTokens,
  setDownloadTokens,
  setSearchTokens,
  setSubscriptionId,
  setUsedDownloadTokens,
  setUsedSearchTokens,
  updateCurrentPeriodEndTimestamp,
} from "./redux/tokens.js";

// Firebase

// Styles
import "./assets/css/style.css";
import GlobalStyles from "./styles/GlobalStyles";

// Pages and Components
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import Swal from "sweetalert2";
import { checkExpiration } from "./utils/checkSubscriptionExpiration.js";
import { useDarkMode } from "./DarkModeProvider.jsx";
import AppRoutes from "./routes.jsx";

// Main App
function App() {
  const dispatch = useDispatch();
  // const [isDarkMode, setIsDarkMode] = useState(true);
  const { isDarkMode, setIsDarkMode } = useDarkMode();

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);

  useEffect(() => {
    setIsDarkMode(isDarkMode);

    const fetchData = async () => {
      const db = getFirestore();
      const userId = localStorage.getItem("uid");
      if (!userId) return;

      try {
        const usersQuery = query(
          collection(db, "Users"),
          where("userId", "==", userId)
        );
        const querySnapshot = await getDocs(usersQuery);

        if (!querySnapshot.empty) {
          // Directly access the first document
          const doc = querySnapshot.docs[0];
          const userData = doc.data();
          console.log("insidee");
        dispatch(
          setAllDataForTokens({
            ...userData?.tokens,
            ...userData?.subscriptionData,
          })
        );

          const res = checkExpiration(userData?.currentPeriodEnd);

          if (res) {
            setTimeout(() => {
              dispatch(setDownloadTokens(0));
              dispatch(setSearchTokens(0));
              dispatch(setUsedSearchTokens(-1));
              dispatch(setUsedDownloadTokens(-1));
              dispatch(setSubscriptionId(null));
              dispatch(updateCurrentPeriodEndTimestamp(null));
              // window.location.reload();
            }, 5000);
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <>
      <GlobalStyles />
      <AppRoutes />
    </>
  );
}

export default App;
